module.exports = __webpack_public_path__ + "img/greece.3d18107a.svg";